import { StatsDto } from "./dto";

export class StatsDownloadService {
  public static exportToCsv(storedReport: StatsDto, name: string): void {
    const array = [];
    array.push(
      `username,timestamp,timestamp,type,id,ssrc,kind,transportId,codecId,packetsReceived,packetsLost,jitter,packetsReceived_s,trackIdentifier,mid,remoteId,lastPacketReceivedTimestamp,headerBytesReceived,packetsDiscarded,fecBytesReceived:,fecPacketsReceived,fecPacketsDiscarded,bytesReceived,nackCount,totalProcessingDelay,estimatedPlayoutTimestamp,jitterBufferDelay,jitterBufferTargetDelay,jitterBufferEmittedCount,jitterBufferMinimumDelay,retransmittedPacketsReceived,retransmittedBytesReceived,rtxSsrc,fecSsrc,packetsDiscarded_s,fecPacketsReceived_s,fecPacketsDiscarded_s,bytesReceived_in_kbits_s,headerBytesReceived_in_kbits_s,retransmittedPacketsReceived_s,retransmittedBytesReceived_in_kbits_s,jitterBufferDelay_jitterBufferEmittedCount_in_ms,jitterBufferTargetDelay_jitterBufferEmittedCount_in_ms,jitterBufferMinimumDelay_jitterBufferEmittedCount_in_ms,totalProcessingDelay_jitterBufferEmittedCount_in_ms,totalSamplesReceived,concealedSamples,silentConcealedSamples,concealmentEvents,insertedSamplesForDeceleration,removedSamplesForAcceleration,audioLevel,totalAudioEnergy,totalSamplesDuration,playoutId,totalSamplesReceived_s,concealedSamples_s,concealedSamples_totalSamplesReceived,silentConcealedSamples_s,insertedSamplesForDeceleration_s,removedSamplesForAcceleration_s,Audio_Level_in_RMS,framesDecoded,keyFramesDecoded,framesRendered,framesDropped,frameWidth,frameHeight,framesPerSecond,qpSum,totalDecodeTime,totalInterFrameDelay,totalSquaredInterFrameDelay,pauseCount,totalPausesDuration,freezeCount,totalFreezesDuration,firCount,pliCount,framesReceived,decoderImplementation,powerEfficientDecoder,framesAssembledFromMultiplePackets,totalAssemblyTime,framesReceived_s,framesReceived_framesDecoded_framesDropped,framesDecoded_s,keyFramesDecoded_s,totalDecodeTime_framesDecoded_in_ms,totalAssemblyTime_framesAssembledFromMultiplePackets_in_ms,totalInterFrameDelay_framesDecoded_in_ms,interFrameDelayStDev_in_ms,qpSum_framesDecoded,packetsSent,bytesSent,packetsSent_s,bytesSent_in_kbits_s,mid,mediaSourceId,remoteId,headerBytesSent,retransmittedPacketsSent,retransmittedBytesSent,rtxSsrc,targetBitrate,totalPacketSendDelay,nackCount,active,headerBytesSent_in_kbits_s,retransmittedPacketsSent_s,retransmittedBytesSent_in_kbits_s,totalPacketSendDelay_packetsSent_in_ms,rid,totalEncodedBytesTarget,frameWidth,frameHeight,framesPerSecond,framesSent,hugeFramesSent,framesEncoded,keyFramesEncoded,qpSum,totalEncodeTime,qualityLimitationReason,qualityLimitationDurations,qualityLimitationResolutionChanges,firCount,pliCount,encoderImplementation,powerEfficientEncoder,scalabilityMode,framesEncoded_s,totalEncodeTime_framesEncoded_in_ms,totalEncodedBytesTarget_in_kbits_s,framesSent_s,totalPacketSendDelay_packetsSent_in_ms,qpSum_framesEncoded,localId,roundTripTime,totalRoundTripTime,fractionLost,roundTripTimeMeasurements,localId,remoteTimestamp,reportsSent,roundTripTime,totalRoundTripTime,roundTripTimeMeasurements,payloadType,transportId,mimeType,clockRate,channels,sdpFmtpLine`
    );
    for (const [username, reports] of Object.entries(storedReport.report)) {
      for (const stat of reports) {
        //RTCInboundAudioRtpStreamStats
        array.push(
          `${username},${stat.timestamp},${
            stat.inbound.audio.timestamp
          },inbound_rtp,${stat.inbound.audio.id},${
            stat.inbound.audio.ssrc
          },audio,${stat.inbound.audio.transportId},${
            stat.inbound.audio.codecId
          },${stat.inbound.audio.packetsReceived},${
            stat.inbound.audio.packetsLost
          },${stat.inbound.audio.jitter},${
            stat.inbound.audio.packetsReceived_s
          },${stat.inbound.audio.trackIdentifier},${stat.inbound.audio.mid},${
            stat.inbound.audio.remoteId
          },${stat.inbound.audio.lastPacketReceivedTimestamp},${
            stat.inbound.audio.headerBytesReceived
          },${stat.inbound.audio.packetsDiscarded},${
            stat.inbound.audio.fecBytesReceived
          },${stat.inbound.audio.fecPacketsReceived},${
            stat.inbound.audio.fecPacketsDiscarded
          },${stat.inbound.audio.bytesReceived},${
            stat.inbound.audio.nackCount
          },${stat.inbound.audio.totalProcessingDelay},${
            stat.inbound.audio.estimatedPlayoutTimestamp
          },${stat.inbound.audio.jitterBufferDelay},${
            stat.inbound.audio.jitterBufferTargetDelay
          },${stat.inbound.audio.jitterBufferEmittedCount},${
            stat.inbound.audio.jitterBufferMinimumDelay
          },${stat.inbound.audio.retransmittedPacketsReceived},${
            stat.inbound.audio.retransmittedBytesReceived
          },${stat.inbound.audio.rtxSsrc},${stat.inbound.audio.fecSsrc},${
            stat.inbound.audio.packetsDiscarded_s
          },${stat.inbound.audio.fecPacketsReceived_s},${
            stat.inbound.audio.fecPacketsDiscarded_s
          },${stat.inbound.audio.bytesReceived_in_kbits_s},${
            stat.inbound.audio.headerBytesReceived_in_kbits_s
          },${stat.inbound.audio.retransmittedPacketsReceived_s},${
            stat.inbound.audio.retransmittedBytesReceived_in_kbits_s
          },${
            stat.inbound.audio.jitterBufferDelay_jitterBufferEmittedCount_in_ms
          },${
            stat.inbound.audio
              .jitterBufferTargetDelay_jitterBufferEmittedCount_in_ms
          },${
            stat.inbound.audio
              .jitterBufferMinimumDelay_jitterBufferEmittedCount_in_ms
          },${
            stat.inbound.audio
              .totalProcessingDelay_jitterBufferEmittedCount_in_ms
          },${stat.inbound.audio.totalSamplesReceived},${
            stat.inbound.audio.concealedSamples
          },${stat.inbound.audio.silentConcealedSamples},${
            stat.inbound.audio.concealmentEvents
          },${stat.inbound.audio.insertedSamplesForDeceleration},${
            stat.inbound.audio.removedSamplesForAcceleration
          },${stat.inbound.audio.audioLevel},${
            stat.inbound.audio.totalAudioEnergy
          },${stat.inbound.audio.totalSamplesDuration},${
            stat.inbound.audio.playoutId
          },${stat.inbound.audio.totalSamplesReceived_s},${
            stat.inbound.audio.concealedSamples_s
          },${stat.inbound.audio.concealedSamples_totalSamplesReceived},${
            stat.inbound.audio.silentConcealedSamples_s
          },${stat.inbound.audio.insertedSamplesForDeceleration_s},${
            stat.inbound.audio.removedSamplesForAcceleration_s
          },${stat.inbound.audio.Audio_Level_in_RMS},${"n/a,".repeat(85)}n/a,${
            stat.inbound.audio.payloadType
          },${stat.inbound.audio.transportId},${stat.inbound.audio.mimeType},${
            stat.inbound.audio.clockRate
          },${stat.inbound.audio.channels},${stat.inbound.audio.sdpFmtpLine}`
        );
        //RTCInboundVideoRtpStreamStats
        array.push(
          `${username},${stat.timestamp},${
            stat.inbound.video.timestamp
          },inbound_rtp,${stat.inbound.video.id},${
            stat.inbound.video.ssrc
          },video,${stat.inbound.video.transportId},${
            stat.inbound.video.codecId
          },${stat.inbound.video.packetsReceived},${
            stat.inbound.video.packetsLost
          },${stat.inbound.video.jitter},${
            stat.inbound.video.packetsReceived_s
          },${stat.inbound.video.trackIdentifier},${stat.inbound.video.mid},${
            stat.inbound.video.remoteId
          },${stat.inbound.video.lastPacketReceivedTimestamp},${
            stat.inbound.video.headerBytesReceived
          },${stat.inbound.video.packetsDiscarded},${
            stat.inbound.video.fecBytesReceived
          },${stat.inbound.video.fecPacketsReceived},${
            stat.inbound.video.fecPacketsDiscarded
          },${stat.inbound.video.bytesReceived},${
            stat.inbound.video.nackCount
          },${stat.inbound.video.totalProcessingDelay},${
            stat.inbound.video.estimatedPlayoutTimestamp
          },${stat.inbound.video.jitterBufferDelay},${
            stat.inbound.video.jitterBufferTargetDelay
          },${stat.inbound.video.jitterBufferEmittedCount},${
            stat.inbound.video.jitterBufferMinimumDelay
          },${stat.inbound.video.retransmittedPacketsReceived},${
            stat.inbound.video.retransmittedBytesReceived
          },${stat.inbound.video.rtxSsrc},${stat.inbound.video.fecSsrc},${
            stat.inbound.video.packetsDiscarded_s
          },${stat.inbound.video.fecPacketsReceived_s},${
            stat.inbound.video.fecPacketsDiscarded_s
          },${stat.inbound.video.bytesReceived_in_kbits_s},${
            stat.inbound.video.headerBytesReceived_in_kbits_s
          },${stat.inbound.video.retransmittedPacketsReceived_s},${
            stat.inbound.video.retransmittedBytesReceived_in_kbits_s
          },${
            stat.inbound.video.jitterBufferDelay_jitterBufferEmittedCount_in_ms
          },${
            stat.inbound.video
              .jitterBufferTargetDelay_jitterBufferEmittedCount_in_ms
          },${
            stat.inbound.video
              .jitterBufferMinimumDelay_jitterBufferEmittedCount_in_ms
          },${
            stat.inbound.video
              .totalProcessingDelay_jitterBufferEmittedCount_in_ms
          },${"n/a,".repeat(16)}n/a,${stat.inbound.video.framesDecoded},${
            stat.inbound.video.keyFramesDecoded
          },${stat.inbound.video.framesRendered},${
            stat.inbound.video.framesDropped
          },${stat.inbound.video.frameWidth},${
            stat.inbound.video.frameHeight
          },${stat.inbound.video.framesPerSecond},${stat.inbound.video.qpSum},${
            stat.inbound.video.totalDecodeTime
          },${stat.inbound.video.totalInterFrameDelay},${
            stat.inbound.video.totalSquaredInterFrameDelay
          },${stat.inbound.video.pauseCount},${
            stat.inbound.video.totalPausesDuration
          },${stat.inbound.video.freezeCount},${
            stat.inbound.video.totalFreezesDuration
          },${stat.inbound.video.firCount},${stat.inbound.video.pliCount},${
            stat.inbound.video.framesReceived
          },${stat.inbound.video.decoderImplementation},${
            stat.inbound.video.powerEfficientDecoder
          },${stat.inbound.video.framesAssembledFromMultiplePackets},${
            stat.inbound.video.totalAssemblyTime
          },${stat.inbound.video.framesReceived_s},${
            stat.inbound.video.framesReceived_framesDecoded_framesDropped
          },${stat.inbound.video.framesDecoded_s},${
            stat.inbound.video.keyFramesDecoded_s
          },${stat.inbound.video.totalDecodeTime_framesDecoded_in_ms},${
            stat.inbound.video
              .totalAssemblyTime_framesAssembledFromMultiplePackets_in_ms
          },${stat.inbound.video.totalInterFrameDelay_framesDecoded_in_ms},${
            stat.inbound.video.interFrameDelayStDev_in_ms
          },${stat.inbound.video.qpSum_framesDecoded},${"n/a,".repeat(54)}n/a,${
            stat.inbound.video.payloadType
          },${stat.inbound.video.transportId},${stat.inbound.video.mimeType},${
            stat.inbound.video.clockRate
          },${stat.inbound.video.channels},${stat.inbound.video.sdpFmtpLine}`
        );
        //RTCOutboundAudioRtpStreamStats
        array.push(
          `${username},${stat.timestamp},${
            stat.outbound.audio.timestamp
          },outbound_rtp,${stat.outbound.audio.id},${
            stat.outbound.audio.ssrc
          },audio,${stat.outbound.audio.transportId},${
            stat.outbound.audio.codecId
          },${"n/a,".repeat(83)}n/a,${stat.outbound.audio.packetsSent},${
            stat.outbound.audio.bytesSent
          },${stat.outbound.audio.packetsSent_s},${
            stat.outbound.audio.bytesSent_in_kbits_s
          },${stat.outbound.audio.mid},${stat.outbound.audio.mediaSourceId},${
            stat.outbound.audio.remoteId
          },${stat.outbound.audio.headerBytesSent},${
            stat.outbound.audio.retransmittedPacketsSent
          },${stat.outbound.audio.retransmittedBytesSent},${
            stat.outbound.audio.rtxSsrc
          },${stat.outbound.audio.targetBitrate},${
            stat.outbound.audio.totalPacketSendDelay
          },${stat.outbound.audio.nackCount},${stat.outbound.audio.active},${
            stat.outbound.audio.headerBytesSent_in_kbits_s
          },${stat.outbound.audio.retransmittedPacketsSent_s},${
            stat.outbound.audio.retransmittedBytesSent_in_kbits_s
          },${
            stat.outbound.audio.totalPacketSendDelay_packetsSent_in_ms
          },${"n/a,".repeat(35)}n/a,${stat.outbound.audio.payloadType},${
            stat.outbound.audio.transportId
          },${stat.outbound.audio.mimeType},${stat.outbound.audio.clockRate},${
            stat.outbound.audio.channels
          },${stat.outbound.audio.sdpFmtpLine}`
        );
        //RTCOutboundVideoRtpStreamStats
        array.push(
          `${username},${stat.timestamp},${
            stat.outbound.video.timestamp
          },outbound_rtp,${stat.outbound.video.id},${
            stat.outbound.video.ssrc
          },video,${stat.outbound.video.transportId},${
            stat.outbound.video.codecId
          },${"n/a,".repeat(83)}n/a,${stat.outbound.video.packetsSent},${
            stat.outbound.video.bytesSent
          },${stat.outbound.video.packetsSent_s},${
            stat.outbound.video.bytesSent_in_kbits_s
          },${stat.outbound.video.mid},${stat.outbound.video.mediaSourceId},${
            stat.outbound.video.remoteId
          },${stat.outbound.video.headerBytesSent},${
            stat.outbound.video.retransmittedPacketsSent
          },${stat.outbound.video.retransmittedBytesSent},${
            stat.outbound.video.rtxSsrc
          },${stat.outbound.video.targetBitrate},${
            stat.outbound.video.totalPacketSendDelay
          },${stat.outbound.video.nackCount},${stat.outbound.video.active},${
            stat.outbound.video.headerBytesSent_in_kbits_s
          },${stat.outbound.video.retransmittedPacketsSent_s},${
            stat.outbound.video.retransmittedBytesSent_in_kbits_s
          },${stat.outbound.video.totalPacketSendDelay_packetsSent_in_ms},${
            stat.outbound.video.rid
          },${stat.outbound.video.totalEncodedBytesTarget},${
            stat.outbound.video.frameWidth
          },${stat.outbound.video.frameHeight},${
            stat.outbound.video.framesPerSecond
          },${stat.outbound.video.framesSent},${
            stat.outbound.video.hugeFramesSent
          },${stat.outbound.video.framesEncoded},${
            stat.outbound.video.keyFramesEncoded
          },${stat.outbound.video.qpSum},${
            stat.outbound.video.totalEncodeTime
          },${stat.outbound.video.qualityLimitationReason},${
            stat.outbound.video.qualityLimitationDurations
          },${stat.outbound.video.qualityLimitationResolutionChanges},${
            stat.outbound.video.firCount
          },${stat.outbound.video.pliCount},${
            stat.outbound.video.encoderImplementation
          },${stat.outbound.video.powerEfficientEncoder},${
            stat.outbound.video.scalabilityMode
          },${stat.outbound.video.framesEncoded_s},${
            stat.outbound.video.totalEncodeTime_framesEncoded_in_ms
          },${stat.outbound.video.totalEncodedBytesTarget_in_kbits_s},${
            stat.outbound.video.framesSent_s
          },${stat.outbound.video.qpSum_framesEncoded},${
            stat.outbound.video.totalPacketSendDelay_packetsSent_in_ms
          },${"n/a,".repeat(10)}n/a,${stat.outbound.video.payloadType},${
            stat.outbound.video.transportId
          },${stat.outbound.video.mimeType},${stat.outbound.video.clockRate},${
            stat.outbound.video.channels
          },${stat.outbound.video.sdpFmtpLine}`
        );
        //RTCRemoteInboundAudioRtpStreamStats
        array.push(
          `${username},${stat.timestamp},${
            stat.remote_inbound.audio.timestamp
          },remote_inbound_rtp,${stat.remote_inbound.audio.id},${
            stat.remote_inbound.audio.ssrc
          },audio,${stat.remote_inbound.audio.transportId},${
            stat.remote_inbound.audio.codecId
          },${stat.remote_inbound.audio.packetsReceived},${
            stat.remote_inbound.audio.packetsLost
          },${stat.remote_inbound.audio.jitter},${
            stat.remote_inbound.audio.packetsReceived_s
          },${"n/a,".repeat(123)}n/a,${stat.remote_inbound.audio.localId}, ${
            stat.remote_inbound.audio.roundTripTime
          },${stat.remote_inbound.audio.totalRoundTripTime},${
            stat.remote_inbound.audio.fractionLost
          },${
            stat.remote_inbound.audio.roundTripTimeMeasurements
          },${"n/a,".repeat(5)}n/a,${stat.remote_inbound.audio.payloadType},${
            stat.remote_inbound.audio.transportId
          },${stat.remote_inbound.audio.mimeType},${
            stat.remote_inbound.audio.clockRate
          },${stat.remote_inbound.audio.channels},${
            stat.remote_inbound.audio.sdpFmtpLine
          }`
        );
        //RTCRemoteInboundVideoRtpStreamStats
        array.push(
          `${username},${stat.timestamp},${
            stat.remote_inbound.video.timestamp
          },remote_inbound_rtp,${stat.remote_inbound.video.id},${
            stat.remote_inbound.video.ssrc
          },video,${stat.remote_inbound.video.transportId},${
            stat.remote_inbound.video.codecId
          },${stat.remote_inbound.video.packetsReceived},${
            stat.remote_inbound.video.packetsLost
          },${stat.remote_inbound.video.jitter},${
            stat.remote_inbound.video.packetsReceived_s
          },${"n/a,".repeat(123)}n/a,${stat.remote_inbound.video.localId}, ${
            stat.remote_inbound.video.roundTripTime
          },${stat.remote_inbound.video.totalRoundTripTime},${
            stat.remote_inbound.video.fractionLost
          },${
            stat.remote_inbound.video.roundTripTimeMeasurements
          },${"n/a,".repeat(5)}n/a,${stat.remote_inbound.video.payloadType},${
            stat.remote_inbound.video.transportId
          },${stat.remote_inbound.video.mimeType},${
            stat.remote_inbound.video.clockRate
          },${stat.remote_inbound.video.channels},${
            stat.remote_inbound.video.sdpFmtpLine
          }`
        );
        //RTCRemoteOutboundAudioRtpStreamStats
        array.push(
          `${username},${stat.timestamp},${
            stat.remote_outbound.audio.timestamp
          },remote_outbound_rtp,${stat.remote_outbound.audio.id},${
            stat.remote_outbound.audio.ssrc
          },audio,${stat.remote_outbound.audio.transportId},${
            stat.remote_outbound.audio.codecId
          },${"n/a,".repeat(83)}n/a,${stat.remote_outbound.audio.packetsSent},${
            stat.remote_outbound.audio.bytesSent
          },${stat.remote_outbound.audio.packetsSent_s},${
            stat.remote_outbound.audio.bytesSent_in_kbits_s
          },${"n/a,".repeat(44)}n/a,${stat.remote_outbound.audio.localId},${
            stat.remote_outbound.audio.remoteTimestamp
          },${stat.remote_outbound.audio.reportsSent},${
            stat.remote_outbound.audio.roundTripTime
          },${stat.remote_outbound.audio.totalRoundTripTime},${
            stat.remote_outbound.audio.roundTripTimeMeasurements
          },${"n/a,".repeat(5)}n/a,${stat.remote_outbound.audio.payloadType},${
            stat.remote_outbound.audio.transportId
          },${stat.remote_outbound.audio.mimeType},${
            stat.remote_outbound.audio.clockRate
          },${stat.remote_outbound.audio.channels},${
            stat.remote_outbound.audio.sdpFmtpLine
          }`
        );
        //RTCRemoteOutboundVideoRtpStreamStats
        array.push(
          `${username},${stat.timestamp},${
            stat.remote_outbound.video.timestamp
          },remote_outbound_rtp,${stat.remote_outbound.video.id},${
            stat.remote_outbound.video.ssrc
          },video,${stat.remote_outbound.video.transportId},${
            stat.remote_outbound.video.codecId
          },${"n/a,".repeat(83)}n/a,${stat.remote_outbound.video.packetsSent},${
            stat.remote_outbound.video.bytesSent
          },${stat.remote_outbound.video.packetsSent_s},${
            stat.remote_outbound.video.bytesSent_in_kbits_s
          },${"n/a,".repeat(44)}n/a,${stat.remote_outbound.video.localId}, ${
            stat.remote_outbound.video.remoteTimestamp
          },${stat.remote_outbound.video.reportsSent},${
            stat.remote_outbound.video.roundTripTime
          },${stat.remote_outbound.video.totalRoundTripTime},${
            stat.remote_outbound.video.roundTripTimeMeasurements
          },${stat.remote_outbound.video.payloadType},${
            stat.remote_outbound.video.transportId
          },${stat.remote_outbound.video.mimeType},${
            stat.remote_outbound.video.clockRate
          },${stat.remote_outbound.video.channels},${
            stat.remote_outbound.video.sdpFmtpLine
          }`
        );
      }
    }
    const blob = new Blob([array.join("\n")], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = `${name}.csv`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  }

  public static exportToJson(storedReport: StatsDto, name: string): void {
    if (storedReport === null) {
      console.warn("No stats to export");
      return;
    }
    const blob = new Blob([JSON.stringify(storedReport, null, 2)], {
      type: "application/json"
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = `${name}.json`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  }
}
